import { useEffect } from 'react'
import { observer } from 'mobx-react-lite'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { useChatbotContext } from 'pages/chatbot/context'
import { ChatbotCollapse } from 'pages/chatbot/ui/ChatbotCollapse'
import { StepQualifyContent } from 'pages/chatbot/ui/ChatbotEdit/StepQualify/ui/StepQualifyContent/StepQualifyContent'

export const StepQualify = observer(() => {
  const { fieldsControl, stepQualifyStore, errorObjectiveQualifyInstruction } = useChatbotContext()
  const { featureFlagsStore } = useEntitiesContext()

  useEffect(() => {
    fieldsControl.init()
    stepQualifyStore.initDefault()

    return () => {
      stepQualifyStore.dispose()
    }
  }, [])

  if (!featureFlagsStore.qualify) return null

  return (
    <ChatbotCollapse
      icon='usersCheck'
      title='Qualify'
      tooltipProps={{
        label: 'Agent will qualify contacts before continuing the conversation',
        placement: 'top',
        sx: { whiteSpace: 'nowrap' },
        maxWidth: 'none',
      }}
      error={errorObjectiveQualifyInstruction}
    >
      <StepQualifyContent type={'default'} />
    </ChatbotCollapse>
  )
})
